import { put } from "redux-saga/effects";

import { DeleteFieldRequestActionType } from "../types";
import { deleteFieldSuccess, deleteFieldFailure } from "../actionCreators";
import { deleteField as deleteFieldFromPage } from "../../pages/actionCreators";
import { FieldsService } from "../../../services/fields";
import axios from "axios";
import { IErrorType } from "../../types/errors.d";
import { undo } from "../../../helpers/undoable";
import { deleteFieldFromLayout, updateLayoutRequest } from "../../layout/actionCreators";

export function* deleteFieldSaga(action: DeleteFieldRequestActionType) {
    const {
        payload: { fieldId, pageId },
    } = action;
    try {
        yield put(deleteFieldFromPage({ pageId, fieldId }));
        yield put(deleteFieldFromLayout({ deleteFieldId: fieldId }));

        yield FieldsService.deleteField(fieldId);
        yield put(deleteFieldSuccess(fieldId));
        yield put(updateLayoutRequest({}));
    } catch (error) {
        yield put(undo(action));
        if (axios.isAxiosError(error))
            yield put(deleteFieldFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(deleteFieldFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
